import React, { useState, useEffect } from 'react';
// import '@aws-amplify/ui-react/styles.css';
import Mqtt5 from './PubSub5-untyped.js';
import { FetchProfiles } from './FetchProfiles.js';
import { ChartTest } from './ChartTest.js';
import { StatBox } from './StatBox.js';
import PlotPointsTest from './PlotPointsTest.js';
// import '@antmedia/videojs-webrtc-plugin';
import {
  useAuthenticator,
  Button,
  Flex,
  Heading,
  View,
  SelectField,
  Divider,
  Badge,
  Text,
  Alert,
  TextField,
  Expander,
  ExpanderItem,
} from '@aws-amplify/ui-react';

import { useParams } from 'react-router-dom';
import TrackMap from './TrackMap.js';
import TrackMapMulti from './TrackMapMulti.js';

export function TelemetryStream() {
  const { username } = useParams();
  const streamUrl = `https://webrtc.hellatightracing.com:5443/WebRTCAppEE/play.html?name=${username}`;
  const [orientation, setOrientation] = useState();
  const [userProfiles, setUserProfiles] = useState([]);
  const [device, setDevice] = useState();
  // const [telemetryPayload, setTelemetryPayload] = useState([]);
  const [telemetryPayload, setTelemetryPayload] = useState({});

  const deviceName = 'htr-003';
  // const activeDeviceNames = ['htr-003'];
  const activeDeviceNames = ['htr-001', 'htr-003'];

  function liftTelemetryPayload(payload, devicename) {
    setTelemetryPayload((previousMessages) => {
      if (!previousMessages.hasOwnProperty(devicename)) {
        previousMessages[devicename] = [];
      }
      const recents = previousMessages[devicename].slice(-100);
      // console.log(recents);
      return { ...previousMessages, [devicename]: [...recents, payload] };
    });
  }

  useEffect(() => {
    const getem = async () => {
      const data = await FetchProfiles();
      await setUserProfiles(data);
      setDevice(data.filter((i) => i.username === username)[0].htrDevice);
    };
    getem().catch(console.error);
  }, [username]);

  let portrait = window.matchMedia('(orientation: portrait)');

  portrait.addEventListener('change', function (e) {
    if (e.matches) {
      // Portrait mode
      setOrientation('portrait');
    } else {
      // Landscape
      setOrientation('landscape');
    }
  });

  return (
    <View textAlign="center">
      <h1>Car #118 - {username}</h1>

      <View
        position="relative"
        maxWidth="800px"
        justifyContent="center"
        margin="auto"
      >
        {/* <Expander type="multiple" isCollapsible={true}>
          <ExpanderItem title="Video" value="thisvalue">
            <View
              style={{
                position: 'relative',
                overflow: 'hidden',
                width: '100%',
                paddingTop: '56.25%',
                borderRadius: '4px',
                border: '4px solid black',
              }}
            >
              <iframe
                title="fun"
                style={{
                  position: 'absolute',
                  left: 0,
                  right: 0,
                  top: 0,
                  bottom: 0,
                  width: '100%',
                  height: '100%',
                }}
                src={streamUrl}
                allowFullScreen
              ></iframe>
            </View>
          </ExpanderItem>
          <ExpanderItem title="Telemetry" value="telemetry">
            <ChartTest my_data={telemetryPayload[deviceName]}></ChartTest>
          </ExpanderItem>
        </Expander> */}
        {activeDeviceNames.map((device) => {
          return (
            <View key={device}>
              <div>this is: {device}</div>
              <Flex>
                <StatBox
                  my_data={telemetryPayload[device]}
                  metric_name="BATTERY"
                ></StatBox>
                <StatBox
                  my_data={telemetryPayload[device]}
                  metric_name="WATER_TEMP"
                ></StatBox>
                <StatBox
                  my_data={telemetryPayload[device]}
                  metric_name="OIL_PRESSURE"
                ></StatBox>
                <StatBox
                  my_data={telemetryPayload[device]}
                  metric_name="RPM"
                ></StatBox>
                <StatBox
                  my_data={telemetryPayload[device]}
                  metric_name="SPEED"
                ></StatBox>
              </Flex>
            </View>
          );
        })}
        {/* <Mqtt5
          liftTelemetryPayload={liftTelemetryPayload}
          topicname="telemetry/htr-003"
        ></Mqtt5> */}
        {activeDeviceNames.map((device_name) => {
          return (
            <Mqtt5
              key={device_name}
              liftTelemetryPayload={liftTelemetryPayload}
              devicename={device_name}
            ></Mqtt5>
          );
        })}
        {/* <Mqtt5 topicname={`telemetry/${device}`}></Mqtt5> */}
        {/* {userProfiles
          .filter((i) => i.username === username)
          .map((option, index) => (
            <div>{option.htrDevice}</div>
          ))} */}
        {/* {userProfiles.filter((i) => i.username === username)[0].htrDevice} */}
        <TrackMapMulti
          my_data={telemetryPayload}
          devicenames={activeDeviceNames}
        />
      </View>
    </View>
  );
}
